import {
  FindAllUserResponse,
  FindAllUsersFilters,
  UserDTO
} from "./dto";
import { UsersServiceImpl } from "./serviceImpl";

export interface UsersService {
  findAllUsers(filters: FindAllUsersFilters): Promise<FindAllUserResponse>;
  findUserByUserId(userid: string): Promise<UserDTO>
  findMe(): Promise<UserDTO>
}

export function NewUsersService(): UsersService {
  return new UsersServiceImpl();
}
